import { createSlice } from '@reduxjs/toolkit';
export const currentUserInitialState = {
    profile: null,
};
const currentUserSlice = createSlice({
    name: 'currentUser',
    initialState: currentUserInitialState,
    reducers: {
        setUserProfile(state, action) {
            state.profile = action.payload;
        },
    },
});
export const { setUserProfile } = currentUserSlice.actions;
export default currentUserSlice.reducer;
